import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import CampaignReports from './CampaignReports.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

export default [
  {
    path: 'wgpt/campaigns/:campaignId?',
    name: 'wgpt_campaign_reports',
    meta,
    component: CampaignReports,
  },
];
